import axios from 'axios';
import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import { initializeMembershipHubApi } from '@zopauk/api-membership-hub';
import { correlationInterceptor, loggerInterceptor, csrfInterceptor } from '@zopauk/libs-axios';

const isDev = env('NEXT_PUBLIC_APP_ENV') === 'development';

export const setMembershipApiConfig = () => {
  // Create a dedicated axios instance without a baseURL prefix
  // The membership hub library will add its own /api prefix
  const instance = axios.create({
    withCredentials: true,
    baseURL: '',
  });

  // Add interceptors to match the main app instance
  csrfInterceptor({ instance });
  correlationInterceptor({ instance });
  loggerInterceptor({
    identifier: 'MEMBERSHIP HUB API',
    instance: instance,
    verbose: isDev,
    logger,
  });

  // Handle 204 No Content responses to prevent retries
  instance.interceptors.response.use(
    (response) => {
      // 204 responses have no body but are successful
      if (response.status === 204) {
        response.data = response.data || {};
      }
      return response;
    },
    (error) => Promise.reject(error),
  );

  return initializeMembershipHubApi(instance);
};
